import { initialState } from './initial';
import { actionTypes } from './actions';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ACTION_PROCESSING: {
      return {
        ...state,
        actionProcessing: action.payload,
      };
    }

    case actionTypes.GET_NOTIFICATIONS: {
      return {
        ...state,
        notifications: action.payload,
      };
    }

    case actionTypes.GET_NEW_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        countOfNewNotifications: action.payload,
      };
    }

    case actionTypes.CHANGE_VISIBILITY_OF_NOTIFICATIONS: {
      return {
        ...state,
        notificationsVisible: !state.notificationsVisible,
      };
    }
    case actionTypes.SET_NOTIFICATION_CLOSED: {
      return {
        ...state,
        notifications: state.notifications.filter((notification) => notification.id !== action.payload),
      };
    }

    default:
      return state;
  }
};
